import { createContext, useContext, useReducer, useMemo } from "react";
import { useNavigate } from "react-router-dom";
// const { fetchRegions } = useContext(PublicationContext);
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Examplad Media Pricing Portal main context
const MaterialUI = createContext();

// Setting custom name for the context which is visible on react dev tools
MaterialUI.displayName = "MaterialUIContext";

// Examplad Media Pricing Portal reducer
function reducer(state, action) {
  switch (action.type) {
    case "MINI_SIDENAV": {
      return { ...state, miniSidenav: action.value };
    }
    case "TRANSPARENT_SIDENAV": {
      return { ...state, transparentSidenav: action.value };
    }
    case "WHITE_SIDENAV": {
      return { ...state, whiteSidenav: action.value };
    }
    case "SIDENAV_COLOR": {
      return { ...state, sidenavColor: action.value };
    }
    case "TRANSPARENT_NAVBAR": {
      return { ...state, transparentNavbar: action.value };
    }
    case "FIXED_NAVBAR": {
      return { ...state, fixedNavbar: action.value };
    }
    case "OPEN_CONFIGURATOR": {
      return { ...state, openConfigurator: action.value };
    }
    case "DIRECTION": {
      return { ...state, direction: action.value };
    }
    case "LAYOUT": {
      return { ...state, layout: action.value };
    }
    case "DARKMODE": {
      return { ...state, darkMode: action.value };
    }
    case "SELECTION": {
      return { ...state, selection: action.value };
    }
    case "REGIONS": {
      return { ...state, regions: action.value };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// Examplad Media Pricing Portal context provider
function MaterialUIControllerProvider({ children }) {
  const initialState = {
    miniSidenav: true,
    transparentSidenav: false,
    whiteSidenav: true,
    sidenavColor: "info",
    transparentNavbar: true,
    fixedNavbar: true,
    openConfigurator: false,
    direction: "ltr",
    layout: "dashboard",
    darkMode: false,
    selection: "publication",
    regions: [],
  };

  const [controller, dispatch] = useReducer(reducer, initialState);
  const navigate = useNavigate();

const fetchRegions = async () => {
  try {
    const sessionToken = localStorage.getItem("sessionToken");
    if (!sessionToken) {
      console.error("Session token not found.");
      return;
    }

    const response = await fetch("https://api.exampladmedia.com/region/getall", {
      method: "GET",
      headers: {
        Authorization: sessionToken,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch regions");
    }

    const data = await response.json();
    const regions = data.data || [];
    dispatch({ type: "REGIONS", value: regions });
  } catch (error) {
    console.error("Error fetching regions:", error.message);
  }
};
  const handleSignOut = () => {
    sessionStorage.clear();
    localStorage.clear();

    navigate("/", { replace: true });

    window.history.pushState(null, "", window.location.href);
    window.history.pushState(null, "", window.location.href);

    window.onpopstate = () => {
      window.history.pushState(null, "", window.location.href);
    };

    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

const value = useMemo(() => [controller, dispatch, handleSignOut, fetchRegions], [controller, dispatch]);


  return <MaterialUI.Provider value={value}>{children}</MaterialUI.Provider>;
}

// Examplad Media Pricing Portal custom hook for using context
function useMaterialUIController() {
  const context = useContext(MaterialUI);

  if (!context) {
    throw new Error(
      "useMaterialUIController should be used inside the MaterialUIControllerProvider."
    );
  }

  return context;
}

// Typechecking props for the MaterialUIControllerProvider
MaterialUIControllerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// Context module functions
const setMiniSidenav = (dispatch, value) => dispatch({ type: "MINI_SIDENAV", value });
const setTransparentSidenav = (dispatch, value) => dispatch({ type: "TRANSPARENT_SIDENAV", value });
const setWhiteSidenav = (dispatch, value) => dispatch({ type: "WHITE_SIDENAV", value });
const setSidenavColor = (dispatch, value) => dispatch({ type: "SIDENAV_COLOR", value });
const setTransparentNavbar = (dispatch, value) => dispatch({ type: "TRANSPARENT_NAVBAR", value });
const setFixedNavbar = (dispatch, value) => dispatch({ type: "FIXED_NAVBAR", value });
const setOpenConfigurator = (dispatch, value) => dispatch({ type: "OPEN_CONFIGURATOR", value });
const setDirection = (dispatch, value) => dispatch({ type: "DIRECTION", value });
const setLayout = (dispatch, value) => dispatch({ type: "LAYOUT", value });
const setDarkMode = (dispatch, value) => dispatch({ type: "DARKMODE", value });
const setSelection = (dispatch, value) => dispatch({ type: "SELECTION", value });

export {
  MaterialUIControllerProvider,
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
  setSidenavColor,
  setTransparentNavbar,
  setFixedNavbar,
  setOpenConfigurator,
  setDirection,
  setLayout,
  setDarkMode,
  setSelection,
};
